// extracted by mini-css-extract-plugin
export default {"inputCheckBox":"CompanyServiceInfo_inputCheckBox__R4lCE"};